import { AiChatBotMessageRef } from './consts';

export default function (editor, opts = {}) {
  const { label, category } = opts;
  const bm = editor.BlockManager;

const style = `
<style>
.${AiChatBotMessageRef} .chatbox-wrapper {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 4rem;
  height: 4rem;
  z-index: 9999;
}

.${AiChatBotMessageRef} .chatbox-toggle {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  color: #fff;
  font-size: 1.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 6px 15px rgba(0,0,0,0.2);
  transition: 0.25s ease-in-out;
}
.${AiChatBotMessageRef} .chatbox-toggle:hover {
  transform: scale(1.1);
}
.${AiChatBotMessageRef} .chatbox-toggle:active {
  transform: scale(0.95);
}

.${AiChatBotMessageRef} .chatbox-message-wrapper {
  position: absolute;
  bottom: calc(100% + 1rem);
  right: 0;
  width: 420px;
  max-height: 520px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0,0,0,0.2);
  transform: scale(0);
  transform-origin: bottom right;
  transition: transform 0.25s ease-in-out;
}
.${AiChatBotMessageRef} .chatbox-message-wrapper.show {
  transform: scale(1);
}

.${AiChatBotMessageRef} .chatbox-message-header {
  background: #4f46e5;
  color: #fff;
  padding: 12px 20px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.${AiChatBotMessageRef} .chatbox-message-close {
  border: none;
  background: transparent;
  font-size: 1.5rem;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
}
.${AiChatBotMessageRef} .chatbox-message-close:hover {
  color: #f87171;
}

.${AiChatBotMessageRef} .chatbox-message-content {
  flex: 1;
  background: #f9fafb;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow-y: auto;
}

.${AiChatBotMessageRef} .chatbox-message-item {
  max-width: 75%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  line-height: 1.4;
  border-radius: 0.75rem;
  animation: fadeInUp 0.3s ease;
}

.${AiChatBotMessageRef} .chatbox-message-item.sent {
  align-self: flex-end;
  background: #4f46e5;   /* blue bubble */
  color: #fff;
  border-radius: 1rem 0.25rem 1rem 1rem;
}

.${AiChatBotMessageRef} .chatbox-message-item.received {
  align-self: flex-start;
  background: #e5e7eb;   /* grey bubble */
  color: #111827;
  border-radius: 0.25rem 1rem 1rem 1rem;
}


.${AiChatBotMessageRef} .chatbox-message-bottom {
  background: #fff;
  padding: 0.75rem 1rem;
  border-top: 1px solid #e5e7eb;
}
.${AiChatBotMessageRef} .chatbox-message-form {
  display: flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 0.75rem;
  padding: 0.5rem 0.75rem;
}
.${AiChatBotMessageRef} .chatbox-message-input {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  font-size: 0.9rem;
  background: transparent;
}
.${AiChatBotMessageRef} .chatbox-message-submit {
  font-size: 1.25rem;
  color: #4f46e5;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.2s;
}
.${AiChatBotMessageRef} .chatbox-message-submit:hover {
  transform: scale(1.1);
}

.chatbox-message-item.typing {
  display: flex;
  align-items: center;
  background: #f0f0f0;
  padding: 8px 12px;
  border-radius: 18px;
}

.chatbox-message-item.typing span {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 2px;
  background: #555;
  border-radius: 50%;
  animation: typing-wave 1.2s infinite ease-in-out;
}

.chatbox-message-item.typing span:nth-child(1) { animation-delay: 0s; }
.chatbox-message-item.typing span:nth-child(2) { animation-delay: 0.2s; }
.chatbox-message-item.typing span:nth-child(3) { animation-delay: 0.4s; }

@keyframes typing-wave {
  0%, 60%, 100% { transform: translateY(0); }
  30% { transform: translateY(-6px); }
}

</style>
`;

bm.add(AiChatBotMessageRef, {
    label: `<i class="webconnect-chat-left-quote"></i><div>${label}</div>`,
    category: category,
    content: `
    <div class="${AiChatBotMessageRef}" data-gjs-type="${AiChatBotMessageRef}" data-js="${AiChatBotMessageRef}">
       <div class="chatbox-wrapper">
        <button class="chatbox-toggle">💬</button>
        <div class="chatbox-message-wrapper">
          <div class="chatbox-message-header">
            <h3>Chat Support</h3>
            <button class="chatbox-message-close">×</button>
          </div>
          <div class="chatbox-message-content">
            <div class="welcome-message">
              Start a conversation with us!
            </div>
             <!-- hidden field stores conversation -->
          <input type="hidden" class="chatbot-conversation" name="chatbotConversation" value="[]" />
          </div>
          <div class="chatbox-message-bottom">
            
        </div>
      </div>
    </div>${style}
`,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="true">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
      </a>
    </span>
  `,
  });
}
